import { render, staticRenderFns } from "./MescladaDetail.vue?vue&type=template&id=8c7af436&scoped=true"
import script from "./MescladaDetail.vue?vue&type=script&lang=js"
export * from "./MescladaDetail.vue?vue&type=script&lang=js"
import style0 from "./MescladaDetail.vue?vue&type=style&index=0&id=8c7af436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7af436",
  null
  
)

export default component.exports